import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { createLoadingSelector, showModal, hideModal } from 'erisxkit/client';
import { bindPromiseCreators } from 'redux-saga-routines';
import { bindActionCreators } from 'redux';
import { getFormValues } from 'redux-form';

import CreateApiKeyModal from '../../components/Profile/CreateApiKeyModal';
import {
  apiCredentialsPermissions as fetchApiCredentialsPermissions,
  API_CREDENTIALS_PERMISSIONS,
  getApiCredentialPermissions,
  createApiCredentialsPromiseCreator,
  CREATE_API_CREDENTIALS,
} from '../../reducers/apiCredentialsReducer';
import EnvPromise from '../../config/env';
import { getLoggedInUser } from '../../reducers/userReducer';

const mapStateToProps = (state) => ({
  apiCredentialsPermissions: getApiCredentialPermissions(state),
  apiCredentialsPermissionsLoading: createLoadingSelector([
    API_CREDENTIALS_PERMISSIONS,
  ])(state),
  creatingCredential: createLoadingSelector([CREATE_API_CREDENTIALS])(state),
  formValues: getFormValues('create-api-key')(state),
  user: getLoggedInUser(state),
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      fetchApiCredentialsPermissions,
      showModal,
      hideModal,
    },
    dispatch,
  ),
  ...bindPromiseCreators(
    {
      createApiCredentialsPromiseCreator,
    },
    dispatch,
  ),
});

export const apiKeyPermissioning = (apiKeyPermissions, enabledPermissions) => {
  const enabledPermissionsList = enabledPermissions.split(',');
  // if apiKeyPermissions is null, not empty array, return the full array of credentials
  if (!apiKeyPermissions) {
    return enabledPermissionsList;
  }
  return enabledPermissionsList.filter((p) => apiKeyPermissions.includes(p));
};

class CreateApiKeyModalContainer extends Component {
  state = {
    credentials: null,
    enabledClearingApiCredentials: [],
  };
  componentDidMount = () => {
    EnvPromise.then(({ enabledClearingApiCredentials = '' }) =>
      this.setState({
        enabledClearingApiCredentials: apiKeyPermissioning(
          get(this.props, ['user', 'apiKeyPermissions'], null),
          enabledClearingApiCredentials,
        ),
      }),
    );
    this.props.fetchApiCredentialsPermissions();
  };
  generateHeader = () =>
    this.state.credentials
      ? 'Your API Key and Secret have been generated.'
      : 'Please enter a label and select the permissions for this key.';
  generateKey = () => {
    const { createApiCredentialsPromiseCreator, formValues } = this.props;
    const args = { ...formValues } || {};

    if (formValues.permissions) {
      args.permissions = Object.keys(formValues.permissions).reduce(
        (arr, p) => {
          formValues.permissions[p] && arr.push(p);
          return arr;
        },
        [],
      );
    }

    createApiCredentialsPromiseCreator({ ...args }).then((successPayload) => {
      const payload = successPayload;
      payload.permissions = successPayload.permissions.reduce(
        (acc, permission) => {
          acc[permission] = true;
          return acc;
        },
        {},
      );
      this.setState({
        credentials: payload,
      });
    });
  };

  render = () => (
    <CreateApiKeyModal
      apiCredentialsPermissions={this.props.apiCredentialsPermissions}
      apiCredentialsPermissionsLoading={
        this.props.apiCredentialsPermissionsLoading
      }
      permissions={this.props.permissions}
      generateKey={this.generateKey}
      credentials={this.state.credentials}
      initialValues={this.state.credentials}
      loading={this.props.creatingCredential}
      header={this.generateHeader()}
      enabledClearingApiCredentials={
        this.state.enabledClearingApiCredentials || []
      }
      formValues={this.props.formValues}
    />
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateApiKeyModalContainer);
